// Shared helper for the request forms' connector-type dropdown. The requester
// picks from the selected station's own connectors when we know them; otherwise
// from the full catalogue (public /api/map/connector-types). "Unknown" is always
// offered. The chosen value posts as `requestedConnectorType`.
import { api } from './api';

let cataloguePromise: Promise<string[]> | null = null;

/** Distinct connector types known in the catalogue, fetched once per page. */
export function fetchConnectorCatalogue(): Promise<string[]> {
  if (!cataloguePromise) {
    cataloguePromise = api()
      .then((client) => client.get<string[]>('/api/map/connector-types'))
      .then((r) => r.data)
      .catch(() => []);
  }
  return cataloguePromise;
}

function esc(s: string): string {
  return s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}

/**
 * Fill a connector-type &lt;select&gt;: the station's own connectors when known,
 * otherwise the full catalogue; a leading placeholder and a trailing "Unknown"
 * (value "unknown") are always present. Deduped case-insensitively.
 */
export function populateConnectorSelect(
  select: HTMLSelectElement,
  stationConnectors: string[],
  catalogue: string[],
  labels: { placeholder: string; unknown: string },
): void {
  const base = stationConnectors.length > 0 ? stationConnectors : catalogue;
  const seen = new Set<string>();
  const opts: string[] = [`<option value="">${esc(labels.placeholder)}</option>`];
  for (const raw of base) {
    const v = (raw ?? '').trim();
    if (!v || v.toLowerCase() === 'unknown' || seen.has(v.toLowerCase())) continue;
    seen.add(v.toLowerCase());
    opts.push(`<option value="${esc(v)}">${esc(v)}</option>`);
  }
  opts.push(`<option value="unknown">${esc(labels.unknown)}</option>`);
  select.innerHTML = opts.join('');
}
